/* eslint-disable */
import gsap from 'gsap';

export default function initLargeCardCarousel() {
    document.querySelectorAll('.large-card-carousel').forEach(( section ) => {
        
        const controlsWrapper = section.querySelector('.slider__controls');
        const cardsWrapper = section.querySelector('.cards-wrapper');
        const cardsContainer = section.querySelector('.cards-group');
        const cards = section.querySelectorAll('.cards-group li.large-card');
        const indicatorsContainer = section.querySelector('.slider-indicators');
        const nextBtn = section.querySelector('.slider-nav-next');
        const prevBtn = section.querySelector('.slider-nav-prev'); 
        let currentIndex = 0;

        const init = () => {
            
            initControls();
            selectCard(0);
            
            window.addEventListener('resize', adjustContainerWidthHeight);
            adjustContainerWidthHeight();
        };

        const adjustContainerWidthHeight = () => {
            
            const wrapperWidth = cardsWrapper.clientWidth;
            let cardHeight = 0;
            let cardWidth = wrapperWidth;
                
            cards.forEach((card, index) => {
                card.classList.add('inited');
                cardHeight = card.clientHeight > cardHeight ? card.clientHeight : cardHeight;
            });

            cards.forEach((card, index) => {
                const cardStyle = window.getComputedStyle(card);
                const flexDirection = cardStyle.getPropertyValue('flex-direction');
                card.style.minHeight = (flexDirection === 'column') ? 'auto' : `${cardHeight}px`;
                card.style.width = (flexDirection === 'column') ? 'auto' : `${wrapperWidth}px`;
            });

            // calculate actual width of the cards container
            let cardsContainerWidth = 0;
            cards.forEach((card, index) => {
                // get left position
                const cardStyle = window.getComputedStyle(card);
                const leftPos = parseFloat(cardStyle.getPropertyValue('left'));
                const totalWidth = cardWidth + leftPos;
                if( totalWidth > cardsContainerWidth ) {
                    cardsContainerWidth = totalWidth;
                }
            });
            
            cardsContainer.style.width = `${cardsContainerWidth}px`;
            cardsContainer.style.minHeight = `${cardHeight}px`;
        };

        const initControls = () => {
            const indicators = indicatorsContainer.querySelectorAll('li');
            
            if( indicators.length <= 1 ) {
                controlsWrapper.style.display = 'none';
            }

            indicators.forEach((indicator, index) => {
                indicator.addEventListener('click', (e) => {
                    selectCard(index);
                });
            });

            prevBtn.addEventListener('click', (e) => {
                selectCard('prev');
            });

            nextBtn.addEventListener('click', (e) => {
                selectCard('next');
            });
        };

        const selectCard = (index) => {
            // Clear all previous "layer" classes from cards
            cards.forEach(card => {
                // Collect all classes that start with "layer"
                let classesToRemove = [];
                card.classList.forEach(className => {
                    if (className.startsWith('layer')) {
                        classesToRemove.push(className);
                    }
                });

                // Remove each class that starts with "layer"
                classesToRemove.forEach(className => {
                    card.classList.remove(className);
                });
            });

            if (typeof index === 'number') {
                // Ensure the index is within the valid range
                if (index >= 0 && index < cards.length) {
                    assignClasses(index);
                } else {
                    console.log('Index out of bounds');
                }
            } else if (index === 'next') {
                // Select the next element
                currentIndex = (currentIndex + 1) % cards.length;
                assignClasses(currentIndex);
            } else if (index === 'prev') {
                // Select the previous element
                currentIndex = (currentIndex - 1 + cards.length) % cards.length;
                assignClasses(currentIndex);
            } else {
                console.log('Invalid index value');
            }

            updateUI();
        }

        // Helper function to assign classes based on the selected index
        const assignClasses = (selectedIndex) => {
            cards[selectedIndex].classList.add('layer1');

            let cnt = 2; 
            for( let i = selectedIndex + 1; i < cards.length; i++ ) {
                cards[i].classList.add(`layer${ cnt++ }`);
                cards[i].classList.add( 'cascade-right' );
            }

            cnt = 2;
            for( let i = selectedIndex - 1 ; i >= 0; i-- ) {
                cards[i].classList.remove('cascade-right');
                cards[i].classList.add(`layer${cnt++}`);
            }
        }

        const updateUI = () => {
            const indicators = indicatorsContainer.querySelectorAll('li');

            indicators.forEach((indicator, index) => {
                if (cards[index].classList.contains('layer1')) {
                    currentIndex = index;
                    indicator.classList.add('active');
                } else {
                    indicator.classList.remove('active');
                }
            });

            if (currentIndex === 0) {
                prevBtn.classList.add('disabled');
            } else {
                prevBtn.classList.remove('disabled');
            }

            if (currentIndex === cards.length - 1) {
                nextBtn.classList.add('disabled');
            } else {
                nextBtn.classList.remove('disabled');
            }
        }

        init();
    });
}
